import { handleStatus500 } from 'api/Utility/HandleStatus500'
import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'
import apiWrapper from 'api/Utility/ApiWrapper'

export const fetchSignUpFormQuestions = async () => {
  const axios = AxiosInitializer({ token: getToken() })
  const URL = `/signup_form_questions`
  const signupFormQuestionEndpoint = () => axios.get(URL)

  const response = await apiWrapper({
    endPoint: signupFormQuestionEndpoint,
    errorFailureAction: handleStatus500,
  })

  return response.data.data
}
